<div class="container" style="width: 100%;height: 100%; text-align: center; align-content: center;">
	<h2 class="h1">Redirecting ...</h2>
</div>